module.exports = __webpack_public_path__ + "static/media/detail_echocardiogram_pg1.24c3ef86.png";